// stores inspired by svelte. these allow you to register callbacks to data
// changes in order to write reactive pages.
// This implementation is missing subtle features from svelte's implementation:
// - It does not fire your subscriber callback immediately after subscribing,
// like svelte does.
// - It does not check if a new value passed to set() is actually different from
// the previous. This may make it inefficient in some situations, where
// subscribers will be notified even when the value doesn't actually change.

type Subscriber<T> = (value: T) => void;
type Updater<T> = (value: T) => T;
type Unsubscriber = () => void;
export class Store<T> {
  constructor(initial_value: T) {
    this.value = initial_value;
  }

  protected value: T;
  protected subscribers: Subscriber<T>[] = [];

  public subscribe(subscriber: Subscriber<T>): Unsubscriber {
    this.subscribers.push(subscriber);

    return () => {
      this.remove_subscriber(subscriber);
    };
  }

  public clear_subscribers() {
    this.subscribers = [];
  }

  public get(): T {
    return this.value;
  }

  public set(new_value: T) {
    this.value = new_value;
    this.subscribers.forEach(callback => callback(this.value));
  }

  public update(updater: Updater<T>) {
    this.set(updater(this.value));
  }

  protected remove_subscriber(subscriber: Subscriber<T>) {
    const index = this.subscribers.indexOf(subscriber);
    if (index !== -1) this.subscribers.splice(index, 1);
  }
}
